import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { api } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import ScheduleManagerView from '@/components/schedules/ScheduleManagerView';

export default function AllSchedulesPage() {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === 'super_admin';

  if (!isSuperAdmin) {
    return (
      <div className="p-8" data-testid="all-schedules-forbidden">
        <div className="max-w-md mx-auto rounded-2xl border border-amber-500/30 bg-amber-500/10 p-6 text-center">
          <AlertTriangle className="w-8 h-8 text-amber-400 mx-auto mb-3" />
          <h2 className="text-lg font-semibold text-white mb-1">Super admin only</h2>
          <p className="text-sm text-zinc-300">Only super admins can view schedules across tenants.</p>
        </div>
      </div>
    );
  }

  return (
    <ScheduleManagerView
      title="All Schedules"
      description="Cross-tenant view of every recurring automation — report bursts, dashboard exports, alerts, anomaly scans and executive briefings. Filter by recipient email to find which schedule is firing."
      testidPrefix="all-schedules"
      showTenant
      loadFn={api.listAllSchedules}
      toggleFn={api.superToggleSchedule}
      deleteFn={api.superDeleteSchedule}
      editFn={api.superEditSchedule}
    />
  );
}
